import { Project, Tool } from './types';
import { hiveKeywordSearch } from './projects/hive-keyword-search';
import { holozing_dec_compare } from './projects/holozing-dec-compare';
import { hiveWheelOfLuck } from './projects/hive-wheel-of-luck';
import { hivePowerUpTracker } from './projects/hive-power-up-tracker';
import { hivePowerDownChecker } from './projects/hive-power-down-checker';
import { hivePostPayoutDashboard } from './projects/hive-post-payout-dashboard';

export const PROJECTS: Project[] = [
  hivePowerUpTracker,
  hivePowerDownChecker,
  hiveKeywordSearch,
  hivePostPayoutDashboard,
  holozing_dec_compare,
  hiveWheelOfLuck,
];

export const TOOLS: Tool[] = [
  { name: 'dhive', icon: 'fa-solid fa-link', description: 'The primary RPC library for Hive.' },
  { name: 'Keychain', icon: 'fa-solid fa-key', description: 'Secure user authentication.' },
  { name: 'HiveSQL', icon: 'fa-solid fa-database', description: 'Structured blockchain queries.' },
  { name: 'Hive-Engine', icon: 'fa-solid fa-coins', description: 'Second-layer token management.' }
];
